// extracted by mini-css-extract-plugin
module.exports = {"resetButtonContainer":"SearchBox_resetButtonContainer_F0b5y"};